import { Spin } from 'antd';
import type { SpinProps } from 'antd';

/**
 * Vòng xoay tải cục bộ (§9.3.9).
 * Dùng cho vùng nhỏ; nếu tải cả màn thì ưu tiên `Skeleton` có hình dạng giống
 * nội dung sắp hiện ra.
 */
export function Spinner(props: SpinProps) {
  return <Spin {...props} />;
}
